import { ExternalLink, MessageCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '../ui/Dialog';

const SUPPORT_CHANNELS = [
    {
        number: '82 99660-9427',
        href: 'https://wa.me/5582996609427',
    },
    {
        number: '82 99696-7906',
        href: 'https://wa.me/5582996967906',
    },
] as const;

type SupportOnlineDialogProps = {
    trigger: ReactNode;
};

export function SupportOnlineDialog({ trigger }: SupportOnlineDialogProps) {
    return (
        <Dialog>
            <DialogTrigger asChild>{trigger}</DialogTrigger>
            <DialogContent className="nx-support-dialog">
                <DialogHeader>
                    <DialogTitle>Suporte online</DialogTitle>
                    <DialogDescription>
                        Escolha um número para falar com nossa equipe pelo WhatsApp.
                    </DialogDescription>
                </DialogHeader>
                <ul className="nx-support-dialog__channels">
                    {SUPPORT_CHANNELS.map((channel) => (
                        <li key={channel.href}>
                            <Button
                                asChild
                                variant="ghost"
                                className="nx-support-dialog__channel-btn"
                            >
                                <a
                                    href={channel.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <MessageCircle size={18} aria-hidden />
                                    <span className="nx-support-dialog__channel-label">
                                        <span>{channel.number}</span>
                                        <small>Falar no WhatsApp</small>
                                    </span>
                                    <ExternalLink
                                        size={14}
                                        aria-hidden
                                        className="nx-support-dialog__external"
                                    />
                                </a>
                            </Button>
                        </li>
                    ))}
                </ul>
            </DialogContent>
        </Dialog>
    );
}
